import React from 'react';
import './Subscription.css';

function Subscription() {
    return (
        <div className='subscription-content'>
            <div className='subscription-info'>
                <h2>Get early access today</h2>
                <p>
                    It only takes a minute to sign up and our free starter tier is
                    extremely generous. If you have any questions, our support team
                    would be happy to help you.
                </p>
            </div>
            <div className='subscription-input'>
                <input type='text' placeholder='example@fylo.com' />
                <button>Get Started For Free</button>
            </div>
        </div>
    );
}

export default Subscription
